import './App.css';
import './assets/css/bootstrap-grid.min.css';
import './assets/css/bootstrap-reboot.min.css';
import './assets/css/default-skin.css';
import './assets/css/main.css';
import Routers from './Routers';

function App() {
  return (
      <div>
        <Routers />
      </div>
  );
}

export default App;
